import {Auth0Provider} from "@auth0/auth0-react";
import {useLocation, useNavigate} from "react-router-dom";
import {SENSITIVE_SCOPE} from "./config/securityContext";


export default function AuthProviderWrapper({children}) {

    const navigate = useNavigate();
    const location = useLocation();


    const getConfig = () => {
        const path = location?.pathname;

        if (path?.startsWith("/admin")) {
            return {
                audience: process.env.REACT_APP_OKTA_ADMIN_AUDIENCE,
                redirect_uri: process.env.REACT_APP_STS_ADMIN_REDIRECT_UI
            }
        }
        return {
            audience: process.env.REACT_APP_OKTA_AUDIENCE,
            redirect_uri: process.env.REACT_APP_STS_OIDC_REDIRECT_UI
        }
    };


    const onRedirectCallback = (appState) => {
        const pendingOperation = appState?.pendingOperation;
        const scope = pendingOperation?.scope;

        sessionStorage.removeItem("pendingOperation");

        if (
            pendingOperation &&
            scope !== SENSITIVE_SCOPE.ENROLL_MFA &&
            scope !== SENSITIVE_SCOPE.UNENROLL_MFA
        ) {
            sessionStorage.setItem(
                "pendingOperation",
                JSON.stringify(pendingOperation)
            );
            return;
        }
        navigate(appState?.returnTo || "/", {
            replace: true,
            state: {
                ...appState,
                action:
                    scope === SENSITIVE_SCOPE.ENROLL_MFA
                        ? "enroll-mfa"
                        : undefined,
            },
        });
    };

    return (
        <Auth0Provider
            domain={process.env.REACT_APP_OKTA_DOMAIN_NAME}
            clientId={process.env.REACT_APP_OKTA_CLIENT_ID}
            authorizationParams={{
                ...getConfig(),
                scope: "openid profile email offline_access",
            }}
            cacheLocation="memory"
            useRefreshTokens={true}
            useRefreshTokensFallback={true}
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
}